import { Materials } from "../constants/Application";

export const MaterialPriceHelper = () => {
  const woocommerceConf = {
    url: process.env.REACT_APP_WOOCOMMERCE_URL ?? "",
    consumerKey: process.env.REACT_APP_WOOCOMMERCE_KEY ?? "",
    consumerSecret: process.env.REACT_APP_WOOCOMMERCE_SECRET ?? "",
    version: "wc/v3",
  };

  const getItemsPrice = async () => {
    const res = new Map<string, string>();
    try {
      for (const material of Object.keys(Materials)) {
        const id = Materials[material as keyof typeof Materials].id;
        const price = await handleProduct(id);
        res.set(id, price);
      }
    } catch (error) {
      console.error("Error fetching material prices:", error);
    }

    return res;
  }

  const handleProduct = async (product: string) => {
    const headersList = {
      Accept: "*/*",
      Authorization:
        `Basic ` +
        btoa(
          `${woocommerceConf.consumerKey}:${woocommerceConf.consumerSecret}`
        ),
    };

    const response = await fetch(
      `${woocommerceConf.url}/wp-json/${woocommerceConf.version}/products/${product}`,
      {
        method: "GET",
        headers: headersList,
      }
    );

    const data = await response.text();

    return JSON.parse(data).price;
  };

  return {
    getItemsPrice
  }
}